'use client';

import Image from 'next/image';
import { useEffect, useRef } from 'react';

import { gsap, ScrollTrigger } from '@/lib/gsap';

import css from './style.module.scss';

const BrandBookScrolledChubs = () => {
	const leftChubRef = useRef<HTMLDivElement>(null);
	const rightChubRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const leftChub = leftChubRef.current;
		const rightChub = rightChubRef.current;

		if (!leftChub || !rightChub) return;

		ScrollTrigger.create({
			onUpdate: self => {
				gsap.set([leftChub, rightChub], { y: self.scroll() * 0.85 });
			}
		});
	}, []);

	return (
		<>
			<div ref={leftChubRef} className={css.leftChub}>
				<Image
					width={543}
					height={645}
					className={css.leftChubImage}
					src="/assets/images/brand-book/chub-fleecy.png"
					alt=""
				/>
			</div>
			<div ref={rightChubRef} className={css.rightChub}>
				<Image
					width={337}
					height={470}
					className={css.rightChubImage}
					src="/assets/images/brand-book/chub-green.png"
					alt=""
				/>
			</div>
		</>
	);
};

export default BrandBookScrolledChubs;
